/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Jobs_Create_New_ButtonInputs */

const en_company_jobs_create_new_button = /** @type {(inputs: Company_Jobs_Create_New_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create New Job`)
};

const de_company_jobs_create_new_button = /** @type {(inputs: Company_Jobs_Create_New_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Stelle anlegen`)
};

/**
* | output |
* | --- |
* | "Create New Job" |
*
* @param {Company_Jobs_Create_New_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_jobs_create_new_button = /** @type {((inputs?: Company_Jobs_Create_New_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Jobs_Create_New_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_jobs_create_new_button(inputs)
	return en_company_jobs_create_new_button(inputs)
});